var render = function render(){
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _vm.setting ? _c('content-view', {
    attrs: {
      "max-width": "1024px"
    }
  }, [_c('v-row', {
    staticClass: "mt-8",
    attrs: {
      "justify": "center",
      "align": "center"
    }
  }, [_c('v-col', {
    staticClass: "pt-0 pb-0 headline text-start",
    attrs: {
      "cols": "auto"
    }
  }, [_vm._v("설정")]), _c('v-spacer'), _c('v-col', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: false,
      expression: "false"
    }],
    staticClass: "pt-0 pb-0",
    attrs: {
      "cols": "auto"
    }
  }, [_c('v-btn', {
    staticClass: "ma-2",
    attrs: {
      "color": "secondary",
      "rounded": ""
    },
    on: {
      "click": function ($event) {
        _vm.showSearch = !_vm.showSearch;
      }
    }
  }, [_c('v-icon', {
    staticClass: "mr-2",
    attrs: {
      "small": ""
    }
  }, [_vm._v("mdi-filter-variant")]), _vm._v("검색필터")], 1)], 1)], 1), _c('v-card', {
    staticClass: "mt-4"
  }, [_c('v-card-title', {
    staticClass: "subtitle-2 font-weight-bold"
  }, [_vm._v(" 상품권 과금설정 ")]), _c('v-divider'), _c('v-data-table', {
    attrs: {
      "items": Object.keys(_vm.setting.riskManagement.giftcard).map(function (level) {
        return {
          level
        };
      }),
      "headers": _vm.giftcardHeaders,
      "hide-default-footer": "",
      "disable-sort": ""
    },
    scopedSlots: _vm._u([{
      key: "item.dailyLimit",
      fn: function (_ref) {
        var item = _ref.item;
        return _c('v-text-field', {
          staticClass: "v-price-field",
          attrs: {
            "hide-details": "",
            "value": _vm.setting.riskManagement.giftcard[item.level].dailyLimit.format()
          },
          on: {
            "input": function (value) {
              return _vm.setting.riskManagement.giftcard[item.level].dailyLimit = +value.replace(/[^0-9]/g, '') || 0;
            }
          }
        }, [_c('v-icon', {
          staticClass: "mt-1",
          attrs: {
            "slot": "prepend-inner",
            "small": ""
          },
          slot: "prepend-inner"
        }, [_vm._v(_vm._s(_vm.mdiCurrencyKrw))])], 1);
      }
    }, {
      key: "item.monthlyLimit",
      fn: function (_ref2) {
        var item = _ref2.item;
        return _c('v-text-field', {
          staticClass: "v-price-field",
          attrs: {
            "hide-details": "",
            "value": _vm.setting.riskManagement.giftcard[item.level].monthlyLimit.format()
          },
          on: {
            "input": function (value) {
              return _vm.setting.riskManagement.giftcard[item.level].monthlyLimit = +value.replace(/[^0-9]/g, '') || 0;
            }
          }
        }, [_c('v-icon', {
          staticClass: "mt-1",
          attrs: {
            "slot": "prepend-inner",
            "small": ""
          },
          slot: "prepend-inner"
        }, [_vm._v(_vm._s(_vm.mdiCurrencyKrw))])], 1);
      }
    }, {
      key: "item.commission",
      fn: function (_ref3) {
        var item = _ref3.item;
        return _c('v-text-field', {
          staticClass: "v-number-field",
          attrs: {
            "hide-details": "",
            "value": _vm.setting.riskManagement.giftcard[item.level].commission.format()
          },
          on: {
            "input": function (value) {
              return _vm.setting.riskManagement.giftcard[item.level].commission = +value.replace(/[^0-9]/g, '') || 0;
            }
          }
        }, [_c('v-icon', {
          staticClass: "mt-1",
          attrs: {
            "slot": "append",
            "small": ""
          },
          slot: "append"
        }, [_vm._v(_vm._s(_vm.mdiPercentOutline))])], 1);
      }
    }], null, false, 3096806755)
  })], 1), _c('v-row', {
    staticClass: "mt-4",
    attrs: {
      "justify": "center"
    }
  }, [_c('v-btn', {
    attrs: {
      "color": "primary"
    },
    on: {
      "click": _vm.save
    }
  }, [_vm._v("저장")])], 1)], 1) : _vm._e();

}
var staticRenderFns = []

export { render, staticRenderFns }